import { DocumentReference, Timestamp } from 'firebase/firestore';

export enum ProductCategory {
    FOOD = "Food",
    BEVERAGES = "Beverages",
    CLOTHING = "Clothing",
    TOYS = "Toys",
    ELECTRONICS = "Electronics",
    SOFTWARELICENSE = "SoftwareLicense",
    OTHER = "Other"
}

export enum ProductType {
    PRODUCT = "Product",
    SERVICE = "Service",
    DIGITAL_PRODUCT = "Digital"
}

export enum ShippingStatus {
    TO_PROCESS = "ToProcess",
    PROCESSING = "Processing",
    SHIPPED = "Shipped",
    DELIVERED = "Delivered",
    CANCELLED = "Cancelled"
}

export interface ProductVariant {
    id: string;
    combination: Record<string, string>; // e.g., { size: 'L', color: 'Red' }
    price: number;
    inventory: number;
    remainingInventory: number;
    sku: string;
}

export type ProductData = {
    id: string;
    type: ProductType;
    productName: string;
    description: string;
    basePrice: number;
    category: ProductCategory;
    sessionsPurchased: number;
    productImages: string[];
    productRef: DocumentReference;
    inventory: number;
    remainingInventory: number;
    minOrderQuantity: number;
    maxOrderQuantity: number;
    isLive: boolean;
    tax: number;
    offerRef: DocumentReference;
    termsAndConditions: string;
    weight: number;
    dimensions: {
        length: number;
        width: number;
        height: number;
    };
    variants: ProductVariant[];
    metaTitle?: string;
    metaDescription?: string;
    keywords?: string[];
    createdAt?: Timestamp;
    updatedAt?: Timestamp;
}

export interface StorefrontData {
    name: string;
    description: string;
    settlementAccountId: number;
    termsAccepted: boolean;
    promoImageUrl?: string;
    GSTIN?: string;
}

export interface OrderItem {
    price: number;
    productId: string;
    quantity: number;
    totalPrice: number;
}

export interface ProductOrder {
    id: string;
    createdAt: Timestamp;
    updatedAt: Timestamp;
    amount: number;
    totalAmountWithPg: number;
    name: string;
    email: string;
    payment_status: string;
    settlement_status: string;
    shipping_status: ShippingStatus;
    items: OrderItem[];
    order_details: {
        itemId: string;
        itemType: string;
        items: Array<{
            price: number;
            productId: string;
            quantity: number;
            totalPrice: number;
        }>;
        totalAmount: number;
        totalAmountWithPg: number;
    };
    paymentMethod?: string;
    paymentTime?: Timestamp;
    platformFees?: number;
    transferAmount?: number;
    settlementId?: string;
    settlementTime?: Timestamp;
    transferId?: string;
    transfer_status?: string;
}

export interface OrdersTabProps {
    orders: ProductOrder[];
    page: number;
    rowsPerPage: number;
    handleChangePage: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
    providerId: string;
    updateOrderInState: (orderId: string, updates: Partial<ProductOrder>) => void;
}

export interface ProductsTabProps {
    products: ProductData[];
    onEditProduct: (product: ProductData) => void;
    onDeleteProduct: (productId: string) => void;
    onToggleLiveStatus: (product: ProductData) => void;
    onAddNewProduct: () => void;
} 